module.exports = __webpack_public_path__ + "assets/images/3894037dc6f9682a2f4d7ed47efff178.png";